
import React, { useState } from 'react';
import axios from 'axios';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import { API_BASE } from '../api';

function groupByDay(fichajes) {
  const days = {};
  fichajes.forEach(f => {
    const day = new Date(f.fecha).toLocaleDateString();
    if (!days[day]) days[day] = [];
    days[day].push(f);
  });
  return days;
}

function MisFichajes({ token, usuarioId, refreshKey }) {
  const [showCalendar, setShowCalendar] = useState(false);
  const [calendarDate, setCalendarDate] = useState('');
  const [fichajesSemana, setFichajesSemana] = useState([]);
  const [loading, setLoading] = useState(false);

  // Selector de semana
  const [semanaOffset, setSemanaOffset] = useState(0); // 0 = actual, -1 = anterior, 1 = siguiente

  const consultar = async () => {
    setLoading(true);
    try {
      const now = new Date();
      const firstDayOfWeek = new Date(now);
      firstDayOfWeek.setDate(now.getDate() - now.getDay() + semanaOffset * 7);
      firstDayOfWeek.setHours(0, 0, 0, 0);
      const lastDayOfWeek = new Date(firstDayOfWeek);
      lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);
      lastDayOfWeek.setHours(23, 59, 59, 999);

      const apiUrlBase = `${API_BASE}/api/fichaje/informe`;
      let urlSemana;
      if (usuarioId && usuarioId !== 'undefined' && usuarioId !== null && usuarioId !== '') {
        urlSemana = `${apiUrlBase}?usuario=${usuarioId}&desde=${encodeURIComponent(firstDayOfWeek.toISOString())}&hasta=${encodeURIComponent(lastDayOfWeek.toISOString())}`;
      } else {
        urlSemana = `${apiUrlBase}?desde=${encodeURIComponent(firstDayOfWeek.toISOString())}&hasta=${encodeURIComponent(lastDayOfWeek.toISOString())}`;
      }
      const resSemana = await axios.get(urlSemana, { headers: { Authorization: `Bearer ${token}` } });
      const semanaData = resSemana.data.sort((a, b) => new Date(b.fecha) - new Date(a.fecha));
      setFichajesSemana(semanaData);
    } catch (err) {
      setFichajesSemana([]);
      console.error('Error al consultar fichajes:', err);
    }
    setLoading(false);
  };

  React.useEffect(() => {
  consultar();
  // eslint-disable-next-line
  }, [semanaOffset, usuarioId, refreshKey]);

  // Calcular rango de semana actual para mostrar
  const getWeekRange = (offset) => {
    const now = new Date();
    const fd = new Date(now);
    fd.setDate(now.getDate() - now.getDay() + offset * 7);
    fd.setHours(0, 0, 0, 0);
    const ld = new Date(fd);
    ld.setDate(fd.getDate() + 6);
    ld.setHours(23, 59, 59, 999);
    return { fd, ld };
  };
  const { fd: semanaInicio, ld: semanaFin } = getWeekRange(semanaOffset);
  const esHoy = semanaOffset === 0;

  return (
    <div className="component-box" style={{
      background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.08) 0%, rgba(118, 75, 162, 0.08) 100%)',
      border: '2px solid rgba(102, 126, 234, 0.15)',
      borderRadius: '20px',
      position: 'relative',
      overflow: 'visible'
    }}>
      <style>{`
        @keyframes mfSlideIn {
          from { opacity: 0; transform: translateY(12px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes mfScaleIn {
          0% { transform: scale(0) rotate(-180deg); }
          100% { transform: scale(1) rotate(0deg); }
        }
        @keyframes mfShimmer {
          0% { background-position: -200% center; }
          100% { background-position: 200% center; }
        }
        @keyframes mfFloat {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-6px); }
        }
        @keyframes mfCalendarDrop {
          0% { opacity: 0; transform: translateX(-50%) translateY(-16px) scale(0.95); }
          60% { opacity: 1; transform: translateX(-50%) translateY(4px) scale(1.02); }
          100% { opacity: 1; transform: translateX(-50%) translateY(0) scale(1); }
        }
        .mf-nav-btn {
          display: flex; align-items: center; justify-content: center;
          width: 40px; height: 40px;
          border-radius: 12px;
          border: 2px solid transparent;
          background:
            linear-gradient(white, white) padding-box,
            linear-gradient(135deg, #667eea 0%, #764ba2 100%) border-box;
          color: #667eea;
          font-size: 1.1rem; font-weight: 800;
          cursor: pointer;
          transition: all 0.25s cubic-bezier(0.4,0,0.2,1);
          flex-shrink: 0;
        }
        .mf-nav-btn:hover {
          transform: scale(1.12);
          box-shadow: 0 4px 14px rgba(102,126,234,0.25);
          background:
            linear-gradient(135deg, rgba(102,126,234,0.08), rgba(118,75,162,0.08)) padding-box,
            linear-gradient(135deg, #667eea 0%, #764ba2 100%) border-box;
        }
        .mf-nav-btn:active { transform: scale(0.96); }

        .mf-week-pill {
          flex: 1;
          display: flex; align-items: center; justify-content: center; gap: 8px;
          padding: 10px 16px;
          border-radius: 14px;
          border: 2px solid rgba(102,126,234,0.2);
          background: linear-gradient(135deg, rgba(255,255,255,0.9), rgba(255,255,255,0.7));
          backdrop-filter: blur(8px);
          cursor: pointer;
          transition: all 0.25s;
          user-select: none;
        }
        .mf-week-pill:hover {
          border-color: rgba(102,126,234,0.45);
          background: linear-gradient(135deg, rgba(102,126,234,0.07), rgba(118,75,162,0.07));
          transform: translateY(-1px);
          box-shadow: 0 4px 14px rgba(102,126,234,0.12);
        }
        .mf-today-badge {
          padding: 3px 10px;
          border-radius: 20px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          font-size: 0.72rem;
          font-weight: 700;
          letter-spacing: 0.5px;
        }

        .mf-calendar-popup {
          position: absolute;
          left: 50%;
          top: calc(100% + 12px);
          transform: translateX(-50%);
          z-index: 50;
          width: 300px;
          background: linear-gradient(135deg, rgba(255,255,255,0.98), rgba(255,255,255,0.95));
          backdrop-filter: blur(20px);
          border: 2px solid rgba(102,126,234,0.2);
          border-radius: 18px;
          box-shadow: 0 20px 60px rgba(102,126,234,0.2), 0 8px 24px rgba(0,0,0,0.1);
          overflow: hidden;
          animation: mfCalendarDrop 0.35s cubic-bezier(0.4,0,0.2,1);
        }
        .mf-calendar-header {
          padding: 16px 20px 14px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          font-weight: 700;
          font-size: 0.95rem;
          display: flex; align-items: center; gap: 8px;
        }
        .mf-calendar-body {
          padding: 18px 20px 16px;
          display: flex; flex-direction: column; gap: 12px;
        }
        .mf-calendar-input {
          width: 100%;
          padding: 11px 14px;
          border: 2px solid rgba(102,126,234,0.2);
          border-radius: 12px;
          font-size: 1rem;
          color: #1e293b;
          background: rgba(102,126,234,0.04);
          outline: none;
          transition: all 0.2s;
          box-sizing: border-box;
        }
        .mf-calendar-input:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 4px rgba(102,126,234,0.1);
        }
        .mf-cal-action {
          flex: 1;
          padding: 10px 0;
          border-radius: 10px;
          border: 2px solid transparent;
          font-weight: 700;
          font-size: 0.9rem;
          cursor: pointer;
          transition: all 0.2s;
        }
        .mf-cal-confirm {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          box-shadow: 0 4px 12px rgba(102,126,234,0.3);
        }
        .mf-cal-confirm:hover { transform: translateY(-2px); box-shadow: 0 6px 18px rgba(102,126,234,0.4); }
        .mf-cal-cancel {
          background: transparent;
          border-color: rgba(102,126,234,0.25);
          color: #667eea;
        }
        .mf-cal-cancel:hover { background: rgba(102,126,234,0.06); border-color: #667eea; }

        .mf-day-header {
          display: inline-flex; align-items: center; gap: 8px;
          padding: 6px 16px;
          border-radius: 20px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          color: white;
          font-size: 0.88rem;
          font-weight: 700;
          letter-spacing: 0.3px;
          box-shadow: 0 3px 10px rgba(102,126,234,0.3);
          margin-bottom: 10px;
        }

        .mf-fichaje-card {
          border-radius: 14px;
          padding: 14px 16px;
          display: flex; flex-direction: column; gap: 8px;
          transition: all 0.25s;
          border-left: 4px solid transparent;
          backdrop-filter: blur(8px);
        }
        .mf-fichaje-card:hover { transform: translateX(4px); }
        .mf-card-entrada {
          background: linear-gradient(135deg, rgba(209,250,229,0.7), rgba(167,243,208,0.5));
          border-left-color: #10b981;
          box-shadow: 0 2px 10px rgba(16,185,129,0.1);
        }
        .mf-card-salida {
          background: linear-gradient(135deg, rgba(254,226,226,0.7), rgba(254,202,202,0.5));
          border-left-color: #ef4444;
          box-shadow: 0 2px 10px rgba(239,68,68,0.1);
        }
        .mf-duracion-badge {
          display: inline-flex; align-items: center; gap: 4px;
          padding: 2px 10px;
          border-radius: 20px;
          background: linear-gradient(135deg, #3b82f6, #1d4ed8);
          color: white;
          font-size: 0.8rem;
          font-weight: 700;
        }
        .mf-empty-state {
          text-align: center;
          padding: 32px 0;
          color: #94a3b8;
        }
        .mf-empty-icon {
          font-size: 3rem;
          margin-bottom: 8px;
          animation: mfFloat 3s ease-in-out infinite;
          display: block;
        }
      `}</style>

      {/* Shimmer top border */}
      <div style={{
        position: 'absolute', top: 0, left: 0, right: 0, height: '4px',
        background: 'linear-gradient(90deg, transparent, #667eea, #764ba2, transparent)',
        backgroundSize: '200% 100%',
        animation: 'mfShimmer 3s linear infinite',
        borderRadius: '20px 20px 0 0'
      }} />

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px' }}>
        <h2 style={{ margin: 0, fontSize: '1.75rem', fontWeight: 700, display: 'flex', alignItems: 'center', gap: '12px', color: '#1e293b' }}>
          <span style={{ animation: 'mfFloat 3s ease-in-out infinite', fontSize: '2.2rem', filter: 'drop-shadow(0 4px 8px rgba(102,126,234,0.3))' }}>📅</span>
          Mis Fichajes
        </h2>
        {!esHoy && (
          <button
            onClick={() => setSemanaOffset(0)}
            style={{
              padding: '6px 14px', borderRadius: '20px',
              border: '2px solid rgba(102,126,234,0.3)',
              background: 'rgba(102,126,234,0.06)',
              color: '#667eea', fontWeight: 700, fontSize: '0.8rem',
              cursor: 'pointer', transition: 'all 0.2s'
            }}
            onMouseEnter={e => { e.currentTarget.style.background = 'rgba(102,126,234,0.12)'; e.currentTarget.style.borderColor = '#667eea'; }}
            onMouseLeave={e => { e.currentTarget.style.background = 'rgba(102,126,234,0.06)'; e.currentTarget.style.borderColor = 'rgba(102,126,234,0.3)'; }}
          >Hoy ↩</button>
        )}
      </div>

      {/* Week navigator */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px', position: 'relative' }}>
        <button className="mf-nav-btn" onClick={() => setSemanaOffset(semanaOffset - 1)} title="Semana anterior">‹</button>

        <div style={{ flex: 1, position: 'relative' }}>
          <div className="mf-week-pill" onClick={() => setShowCalendar(v => !v)} title="Seleccionar semana">
            <span style={{ fontSize: '1rem' }}>📆</span>
            <span style={{ fontSize: '0.9rem', fontWeight: 600, color: '#1e293b' }}>
              {semanaInicio.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' })}
              {' — '}
              {semanaFin.toLocaleDateString('es-ES', { day: 'numeric', month: 'short', year: 'numeric' })}
            </span>
            {esHoy && <span className="mf-today-badge">HOY</span>}
            <span style={{ color: '#667eea', fontSize: '0.8rem', marginLeft: 'auto' }}>▾</span>
          </div>

          {showCalendar && (
            <div className="mf-calendar-popup">
              <div className="mf-calendar-header">
                <span>📆</span>
                Seleccionar semana
              </div>
              <div className="mf-calendar-body">
                <label style={{ fontSize: '0.85rem', fontWeight: 600, color: '#475569' }}>
                  Elige cualquier día de la semana:
                </label>
                <input
                  type="date"
                  className="mf-calendar-input"
                  value={calendarDate}
                  onChange={e => setCalendarDate(e.target.value)}
                />
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button
                    className="mf-cal-action mf-cal-confirm"
                    onClick={() => {
                      if (calendarDate) {
                        const selected = new Date(calendarDate);
                        const now = new Date();
                        const startNow = new Date(now);
                        startNow.setDate(now.getDate() - now.getDay());
                        startNow.setHours(0,0,0,0);
                        const startSel = new Date(selected);
                        startSel.setDate(selected.getDate() - selected.getDay());
                        startSel.setHours(0,0,0,0);
                        const offset = Math.round((startSel - startNow) / (7*24*60*60*1000));
                        setSemanaOffset(offset);
                        setShowCalendar(false);
                      }
                    }}
                  >✓ Ir a semana</button>
                  <button className="mf-cal-action mf-cal-cancel" onClick={() => setShowCalendar(false)}>Cancelar</button>
                </div>
              </div>
            </div>
          )}
        </div>

        <button className="mf-nav-btn" onClick={() => setSemanaOffset(semanaOffset + 1)} title="Semana siguiente">›</button>
      </div>

      {/* Separador */}
      <div style={{
        height: '2px',
        background: 'linear-gradient(90deg, transparent, rgba(102,126,234,0.2), transparent)',
        borderRadius: '2px',
        marginBottom: '20px'
      }} />

      {/* Lista de fichajes */}
      {(!fichajesSemana || fichajesSemana.length === 0) ? (
        <div className="mf-empty-state">
          <span className="mf-empty-icon">🗓️</span>
          <p style={{ margin: 0, fontSize: '1rem', fontWeight: 600 }}>Sin fichajes esta semana</p>
          <p style={{ margin: '4px 0 0', fontSize: '0.85rem' }}>No se han registrado entradas ni salidas</p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          {Object.entries(groupByDay(fichajesSemana)).map(([dia, fichajesDia]) => (
            <div key={dia}>
              <div className="mf-day-header">
                <span>📌</span>
                {dia}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {fichajesDia.map((f) => (
                  <div
                    key={f._id}
                    className={`mf-fichaje-card ${f.tipo === 'entrada' ? 'mf-card-entrada' : 'mf-card-salida'}`}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      {f.tipo === 'entrada'
                        ? <LoginIcon style={{ color: '#10b981', fontSize: 22, flexShrink: 0 }} />
                        : <LogoutIcon style={{ color: '#ef4444', fontSize: 22, flexShrink: 0 }} />
                      }
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                          <span style={{
                            fontWeight: 700, fontSize: '1rem',
                            color: f.tipo === 'entrada' ? '#065f46' : '#991b1b'
                          }}>
                            {f.tipo === 'entrada' ? 'Entrada' : 'Salida'}
                          </span>
                          <span style={{ fontWeight: 600, fontSize: '1rem', color: '#1e293b' }}>
                            {new Date(f.fecha).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                          </span>
                          {f.tipo === 'salida' && typeof f.duracion === 'number' && (
                            <span className="mf-duracion-badge">
                              ⏱ {Math.floor(Math.abs(f.duracion) / 60)}h {Math.abs(f.duracion) % 60}min
                            </span>
                          )}
                        </div>
                        {f.dispositivo?.marca && (
                          <span style={{ fontSize: '0.78rem', color: '#94a3b8' }}>
                            {f.dispositivo.marca} {f.dispositivo.modelo}
                          </span>
                        )}
                      </div>
                    </div>
                    {f.ubicacion && (f.ubicacion.latitud || f.ubicacion.longitud) && (
                      <div style={{
                        display: 'flex', alignItems: 'center', gap: '6px',
                        fontSize: '0.8rem', color: '#64748b',
                        paddingLeft: '34px'
                      }}>
                        <span>📍</span>
                        <span>
                          {f.ubicacion.latitud?.toFixed(5)}, {f.ubicacion.longitud?.toFixed(5)}
                          {f.ubicacion.precision && (
                            <span style={{ marginLeft: 6, color: '#94a3b8' }}>
                              (±{Math.round(f.ubicacion.precision)}m)
                            </span>
                          )}
                        </span>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default MisFichajes;